import React from "react"
import { Button } from "reactstrap"
export default function AdmissionButton({ id, reason, children, ...props }) {
  return <span title={reason || undefined} tabIndex={reason ? 0 : undefined} aria-describedby={reason ? id : undefined}>
    <Button {...props} disabled={Boolean(reason)} aria-describedby={reason ? id : undefined} style={reason ? { pointerEvents: "none" } : undefined}>{children}</Button>
    {reason && <span id={id} className="sr-only">{reason}</span>}
  </span>
}
